import {createApp} from 'vue';
import {createPinia} from 'pinia';
import App from './App.vue';
import router from './router';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

// import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'sweetalert2/dist/sweetalert2.min.css';
import '../public/css/custom.css';
import './components/modules/crewIncident/page.css';
import "@vueform/multiselect/themes/default.css";
import $ from 'jquery';
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net';
import iconConfig from "@/config/icons.config";
import axiosConfig from "@/config/axios.config";
import componentConfig from "@/config/component.config";
import Popper from 'popper.js';
import {TOKEN} from "@/config/constants.config";
import Cookies from 'js-cookie';
import '@vuepic/vue-datepicker/dist/main.css';
import '@night-owl-elite/vue-select/style.css';


const migrateAuthDataToCookies = () => {
    const keysToMigrate = [
        TOKEN.BOUVET,
        'authUser',
        'isSetupAccess',
        'b4Expired'
    ];

    console.log('Starting atomic check for data migration...');
    const allKeysExist = keysToMigrate.every(key => localStorage.getItem(key) !== null);

    if (allKeysExist) {
        console.log('All required keys found. Migrating to cookies...');

        keysToMigrate.forEach(key => {
            const value = localStorage.getItem(key);

            Cookies.set(key, value, {expires: 7, secure: true, sameSite: 'Lax'});
            console.log(`- Cookie created for '${key}'.`);

            localStorage.removeItem(key);
        });

        console.log('Atomic migration successful. Local Storage has been cleared of these keys.');

    } else {
        console.log('One or more required keys are missing. Cleaning up incomplete data from Local Storage...');

        keysToMigrate.forEach(key => {
            if (localStorage.getItem(key) !== null) {
                localStorage.removeItem(key);
                console.log(`- Removed orphaned key: '${key}'`);
            }
        });

        console.log('Cleanup complete. No data was migrated to cookies.');
    }
};

migrateAuthDataToCookies();
const app = createApp(App);
app.use(createPinia());
DataTable.use(DataTablesCore);
iconConfig();
axiosConfig();
app.use(router);
componentConfig(app);
window.$ = $;
window.Popper = Popper;
app.mount('#app');
